import React from 'react'
import {
    Grid,
    TextField,
    Checkbox,
    Button,

} from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';

import Box from '@mui/material/Box';

import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import services from '../../../Services';
import { Imports } from '../../../Imports';
import Snackbar from '../../../Components/Snackbar';

import { environment as env } from '../../../environments/environment';

const {
    users,
    Storage,
} = services;

const ApplicantForget = () => {
    const storage = new Storage();
    const history = useHistory();
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [isLoggingIn, setIsLoggingIn] = useState(false);
    const [password, setPassword] = useState(false);

    const showSnackBar = (messageToShow) => {
        const snackbarTriggerEvent = new CustomEvent(
            'trigger-snackbar',
            {
                detail: {
                    messageToShow
                }
            }
        );

        window.dispatchEvent(snackbarTriggerEvent)
    }

    const validatePassword = async (password) => {
        try {
            return await Imports
                .validators
            // .password
            // .validate(password);
        } catch (exc) {
            showSnackBar(exc.message);
            throw exc;
        }
    }
    const ForgetUser = async (e) => {
        e.preventDefault()

        try {
            setIsLoggingIn(true);

            const { email } = values;

            const payload = { email };

            /** Disabled for AD Users */
            let response = await fetch(`${env?.apiPath}employee/forgetPassword`,
                {
                    method: 'POST',
                    headers: {
                        'content-type': 'application/json',
                    },
                    body: JSON.stringify(payload)
                });
             
            const {
                statusText,
                status
            } = response;

            if (status !== 200)
                return showSnackBar(statusText)
            handleOpen(true)


            return true;

        } catch (exc) {
            setIsLoggingIn(false);

             

            return false;
        }
        // window.location = '/dashboard';
    };


    const [values, setValues] = useState({
        amount: '',
        password: '',
        weight: '',
        weightRange: '',
        showPassword: false,
    });

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        height: 250,
        bgcolor: 'background.paper',
        // border: '2px solid #000',
        borderRadius: '20px',
        boxShadow: 24,
        p: 4,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    };



    const handleChange = (prop) => (event) => {
        setValues({ ...values, [prop]: event.target.value });
    };

    return (
        <div><Grid container xs={12}>
            <Grid className="applicantImageBG">
                {/* <Grid className="applicantImage">
                </Grid> */}
            </Grid>
            <Grid className="LoginFormPlace">
                <Grid className="LoginForm">
                    <Grid className="LoginTitle"> Forget Password</Grid>
                    <Grid className="FormFields">
                        <form onSubmit={ForgetUser}>
                            <TextField placeholder="Email Address"
                                type="email"
                                required={true}
                                onChange={handleChange('email')} error={'asnkjasd'}
                                style={{ background: 'white', padding: '10px', borderRadius: '10px' }}
                                onKeyPress={event => {
                                    if (event.key === 'Enter') {
                                        ForgetUser()
                                    }
                                }}
                            />
                            <Grid xs={12} container justify="center" className="mt26">
                                <Button className="LoginBtn" type='submit'
                                >Forget Password</Button>
                                <Modal
                                    open={open}
                                    onClose={handleClose}
                                    aria-labelledby="modal-modal-title"
                                    aria-describedby="modal-modal-description"
                                >
                                    <Box sx={style}>

                                        <Typography id="modal-modal-description" sx={{ mt: 2 }} style={{ textAlign: 'center' }}>
                                            We wanted to let you know that we have sent an email to help you reset your password. Please check your inbox for further instructions.
                                            If you do not see the email in your inbox, please check your spam or junk folder.                                    </Typography>
                                        <Link to="/" className="ApplicantBtn1" style={{ marginTop: '30px', }}>OK</Link>
                                    </Box>
                                </Modal>
                            </Grid>
                        </form>

                        {/* <Grid xs={12} container justify="center" className="mt20">
             
              <a href="application" className="ApplicantBtn">Submit Application & Create Account</a>
              <a href="login" className="ApplicantBtn">Already an Employee?</a>
            </Grid> */}
                    </Grid>
                    <Snackbar />
                </Grid>
            </Grid>
        </Grid></div>
    )
}

export default ApplicantForget